// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/panel.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-designer {
  background-color: #f0f2f5;
}
.dashboard-designer .text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dashboard-designer .middle {
  vertical-align: middle;
}
.dashboard-designer .jzliu-bi-engine-bi-header-name-input {
  transition: 0.3s all;
  width: 300px;
  min-width: 150px;
  border: 1px solid transparent;
  box-shadow: none;
  font-size: 16px;
  background-color: transparent;
  color: var(--bi-jz-font-color);
  height: 30px;
  padding: 0 10px;
  outline: none;
}
.dashboard-designer .jzliu-bi-engine-bi-header-name-input:hover {
  border: 1px solid #2e74ff;
}
.dashboard-designer .jzliu-bi-engine-bi-header-btn {
  min-width: 108px;
  height: 26px;
  border-radius: 20px;
  border: 1px solid #2e74ff;
  color: var(--bi-jz-font-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
}
.dashboard-designer .jzliu-bi-engine-bi-header-btn.primary {
  background: #2e74ff;
}
.dashboard-designer .jzliu-bi-engine-bi-header-btn.default {
  background: transparent;
}
.dashboard-designer .close-setting-panel {
  width: 40px !important;
}
.dashboard-designer .close-setting-panel .el-icon-s-unfold {
  transform: rotate(180deg);
}
.dashboard-designer .self-icon {
  color: var(--bi-jz-font-color);
  position: absolute;
  right: 12px;
  display: inline-flex;
  margin-top: 14px;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.dashboard-designer .jzliu-bi-engine-chart-warp {
  width: 100%;
  height: 100%;
}
.dashboard-designer .shadow {
  border-color: #468cff !important;
}
.dashboard-designer li {
  list-style: none;
}
.dashboard-designer .el-button--primary {
  width: 100%;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 2px;
  background-color: #2e74ff;
  border-color: #2e74ff;
  border-radius: 0;
}
.dashboard-designer .el-button--primary:hover {
  background-color: #4794ff;
  border-color: #4794ff;
}
.dashboard-designer .drag-warp {
  width: 100%;
  height: 100%;
}
.dashboard-designer .components-widgets {
  display: flex;
  align-items: center;
}
.dashboard-designer .component-type-cross-table {
  background-position: 15px -875px;
}
.dashboard-designer .component-type-bar {
  background-position: -143px -875px;
}
.dashboard-designer .component-type-pie {
  background-position: -543px -875px;
}
.dashboard-designer .component-type-line {
  background-position: -306px -875px;
}
.dashboard-designer .component-type-indicator-card {
  background-position: -63px -875px;
}
.dashboard-designer .component-type-gauge {
  background-position: -700px -880px;
}
.dashboard-designer .seprate {
  border-right: 1px solid hsla(0, 0%, 100%, 0.3);
  width: 0;
  height: 20px;
  margin: 0 4px;
}
.dashboard-designer .components-item {
  width: 35px;
  height: 35px;
  border-radius: 2px;
  margin: 0 2px;
}
.dashboard-designer .components-item :hover {
  background-color: hsla(0, 0%, 100%, 0.15);
}
.dashboard-designer .components-item > div {
  width: 70px;
  height: 70px;
  display: block;
  position: relative;
  left: 0;
  top: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  transform-origin: left top;
  cursor: pointer;
}
.dashboard-designer .require-icon {
  color: #f23c3c;
  font-size: 14px;
  margin-right: 4px;
}
.dashboard-designer .vue-grid-item.vue-grid-placeholder {
  background: #ada3a3;
}
.dashboard-designer .ui-schema-antd-tree {
  flex-grow: 1;
  overflow-y: auto;
  padding: 8px 12px;
  padding-top: 0;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  margin: 0;
}
.dashboard-designer .ui-schema-antd-tree > li {
  padding: 2px 0;
}
.dashboard-designer .ui-schema-antd-tree li {
  margin: 0;
  padding: 4px 0;
  white-space: nowrap;
  list-style: none;
  outline: 0;
}
.dashboard-designer .ui-schema-antd-tree .field-tree-left {
  cursor: pointer;
}
.dashboard-designer .ui-schema-antd-tree .field-tree-left li .field-tree-item-warp {
  padding-left: 29px;
}
.dashboard-designer .ui-schema-antd-tree .field-tree-left ul {
  padding-left: 0;
}
.dashboard-designer .ui-schema-antd-tree .field-tree-left .open-rotate {
  transform: rotate(90deg);
}
.dashboard-designer .ui-schema-antd-tree .field-tree-left .el-icon-caret-right {
  transition: all 0.3s;
  color: var(--bi-jz-font-color);
  font-size: 12px;
}
.dashboard-designer .ui-schema-antd-tree .field-tree-left .field-tree-item-warp-flex {
  display: flex;
  align-items: center;
}
.dashboard-designer .ui-schema-antd-tree .field-tree-left .field-tree-item-warp {
  transition: all 0.3s;
  flex: 1;
  margin-left: 4px;
}
.bi_dashboard_text_overflow .dashboard-designer .ui-schema-antd-tree .field-tree-left .field-tree-item-warp:hover {
  background-color: hsla(0, 0%, 100%, 0.1);
}
.dashboard-designer .ui-schema-antd-tree .field-tree-left .field-tree-text {
  max-width: 140px;
  color: var(--bi-jz-font-color);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  line-height: 1;
}
.jzliu-bi-engine-vertical-text {
  height: 60px;
  width: 100%;
  color: var(--bi-jz-font-color);
  font-size: 14px;
  letter-spacing: 3px;
  writing-mode: tb-rl;
  writing-mode: vertical-lr;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.jzliu-bi-engine-vertical-text:hover {
  color: #5890FF;
}
/* Element UI 组件 label 样式 */
.cdsp_dashboard .el-input__label,
.cdsp_dashboard .el-form-item__label,
.cdsp_dashboard .el-checkbox__label,
.cdsp_dashboard .el-radio__label,
.cdsp_dashboard .el-select__label,
.cdsp_dashboard .el-cascader__label,
.cdsp_dashboard .el-date-editor__label,
.cdsp_dashboard .el-time-picker__label,
.cdsp_dashboard .el-switch__label,
.cdsp_dashboard .el-slider__label,
.cdsp_dashboard .el-rate__label,
.cdsp_dashboard .el-color-picker__label,
.cdsp_dashboard .el-transfer__label,
.cdsp_dashboard .el-upload__label,
.cdsp_dashboard .el-button__label,
.cdsp_dashboard .el-tag__label,
.cdsp_dashboard .el-badge__label,
.cdsp_dashboard .el-alert__label,
.cdsp_dashboard .el-message__label,
.cdsp_dashboard .el-notification__label,
.cdsp_dashboard .el-dialog__label,
.cdsp_dashboard .el-drawer__label,
.cdsp_dashboard .el-popover__label,
.cdsp_dashboard .el-tooltip__label,
.cdsp_dashboard .el-pagination__label,
.cdsp_dashboard .el-table__label,
.cdsp_dashboard .el-tree__label,
.cdsp_dashboard .el-menu__label,
.cdsp_dashboard .el-breadcrumb__label,
.cdsp_dashboard .el-steps__label,
.cdsp_dashboard .el-tabs__label,
.cdsp_dashboard .el-card__label,
.cdsp_dashboard .el-collapse__label,
.cdsp_dashboard .el-timeline__label,
.cdsp_dashboard .el-carousel__label,
.cdsp_dashboard .el-image__label,
.cdsp_dashboard .el-avatar__label,
.cdsp_dashboard .el-skeleton__label,
.cdsp_dashboard .el-empty__label,
.cdsp_dashboard .el-result__label,
.cdsp_dashboard .el-descriptions__label,
.cdsp_dashboard .el-calendar__label,
.cdsp_dashboard .el-backtop__label,
.cdsp_dashboard .el-affix__label,
.cdsp_dashboard .el-anchor__label,
.cdsp_dashboard .el-page-header__label,
.cdsp_dashboard .el-divider__label,
.cdsp_dashboard .el-link__label,
.cdsp_dashboard .el-text__label,
.cdsp_dashboard .el-space__label,
.cdsp_dashboard .el-scrollbar__label,
.cdsp_dashboard .el-infinite-scroll__label,
.cdsp_dashboard .el-loading__label,
.cdsp_dashboard .el-message-box__label,
.cdsp_dashboard .el-popconfirm__label,
.cdsp_dashboard .el-autocomplete__label,
.cdsp_dashboard .el-input-number__label,
.cdsp_dashboard .el-rate__label,
.cdsp_dashboard .el-slider__label,
.cdsp_dashboard .el-switch__label,
.cdsp_dashboard .el-time-select__label,
.cdsp_dashboard .el-time-picker__label,
.cdsp_dashboard .el-date-picker__label,
.cdsp_dashboard .el-date-range-picker__label,
.cdsp_dashboard .el-month-picker__label,
.cdsp_dashboard .el-year-picker__label,
.cdsp_dashboard .el-week-picker__label,
.cdsp_dashboard .el-quarter-picker__label,
.cdsp_dashboard .el-datetime-picker__label,
.cdsp_dashboard .el-datetime-range-picker__label {
  font-size: 12px !important;
}
.cdsp_dashboard .sortable-ghost {
  margin: 9px 9px;
  padding: 4px 8px;
  background-color: var(--color-primary);
  border: 1px dashed var(--color-primary);
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/dashboard.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;AADF;AAAA;EAGI,gBAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AALA;EAQI,sBAAA;AAAJ;AARA;EAaI,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAFJ;AAGI;EACE,yBAAA;AADN;AAxBA;EA+BI,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AAJJ;AApCA;EA4CI,mBAAA;AALJ;AAvCA;EAgDI,uBAAA;AANJ;AA1CA;EAoDI,sBAAA;AAPJ;AA7CA;EAuDM,yBAAA;AAPN;AAhDA;EA4DI,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AATJ;AA1DA;EAuEI,WAAA;EACA,YAAA;AAVJ;AA9DA;EA4EI,gCAAA;AAXJ;AAjEA;EAgFI,gBAAA;AAZJ;AApEA;EAoFI,WAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAbJ;AAeI;EACE,yBAAA;EACA,qBAAA;AAbN;AAjFA;EAmGI,WAAA;EACA,YAAA;AAfJ;AArFA;EAwGI,aAAA;EACA,mBAAA;AAhBJ;AAzFA;EAgHI,gCAAA;AApBJ;AA5FA;EAoHI,kCAAA;AArBJ;AA/FA;EAwHI,kCAAA;AAtBJ;AAlGA;EA4HI,kCAAA;AAvBJ;AArGA;EAgII,iCAAA;AAxBJ;AAxGA;EAoII,kCAAA;AAzBJ;AA3GA;EAyII,8CAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;AA3BJ;AAjHA;EAgJI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AA5BJ;AAvHA;EAsJM,yCAAA;AA5BN;AA1HA;EA0JM,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,yDAAA;EACA,4BAAA;EACA,6BAAA;EACA,qBAAA;EACA,0BAAA;EACA,eAAA;AA7BN;AAxIA;EA0KI,cAAA;EACA,eAAA;EACA,iBAAA;AA/BJ;AA7IA;EAgLI,mBAAA;AAhCJ;AAhJA;EAoLI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;AAjCJ;AA9JA;EAkMM,cAAA;AAjCN;AAjKA;EAsMM,SAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AAlCN;AAxKA;EA8MM,eAAA;AAnCN;AA3KA;EAkNU,kBAAA;AApCV;AA9KA;EAuNQ,eAAA;AAtCR;AAjLA;EA2NQ,wBAAA;AAvCR;AApLA;EA+NQ,oBAAA;EACA,8BAAA;EACA,eAAA;AAxCR;AAzLA;EAqOQ,aAAA;EACA,mBAAA;AAzCR;AA7LA;EA0OQ,oBAAA;EACA,OAAA;EACA,gBAAA;AA1CR;AA2CQ;EAGE,wCAAA;AA3CV;AArMA;EAqPQ,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AA7CR;AAmDA;EACE,YAAA;EACA,WAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EAEA,mBAAA;EACA,yBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAnDF;AAoDE;EACE,cAAA;AAlDJ;AACA,2BAA2B;AAsD3B;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqEE,0BAAA;AAnDF;AAsDA;EACE,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,uCAAA;EACA,sBAAA;AApDF","sourcesContent":["@base-color: var(--bi-jz-font-color);\n@color1: #2e74ff;\n.dashboard-designer {\n  background-color: #f0f2f5;\n  .text-overflow{\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  .middle{\n    vertical-align: middle;\n  }\n\n  //input\n  .jzliu-bi-engine-bi-header-name-input {\n    transition: 0.3s all;\n    width: 300px;\n    min-width: 150px;\n    border: 1px solid transparent;\n    box-shadow: none;\n    font-size: 16px;\n    background-color: transparent;\n    color: var(--bi-jz-font-color);\n    height: 30px;\n    padding: 0 10px;\n    outline: none;\n    &:hover {\n      border: 1px solid @color1;\n    }\n  }\n\n  //button\n  .jzliu-bi-engine-bi-header-btn {\n    min-width: 108px;\n    height: 26px;\n    border-radius: 20px;\n    border: 1px solid @color1;\n    color: var(--bi-jz-font-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    cursor: pointer;\n  }\n\n  .jzliu-bi-engine-bi-header-btn.primary {\n    background: @color1;\n  }\n\n  .jzliu-bi-engine-bi-header-btn.default {\n    background: transparent;\n  }\n\n  .close-setting-panel {\n    width: 40px !important;\n\n    .el-icon-s-unfold {\n      transform: rotate(180deg);\n    }\n  }\n\n  .self-icon {\n    color: @base-color;\n    position: absolute;\n    right: 12px;\n    display: inline-flex;\n    margin-top: 14px;\n    font-size: 20px;\n    cursor: pointer;\n    transition: all .2s ease;\n  }\n\n  .jzliu-bi-engine-chart-warp {\n    width: 100%;\n    height: 100%;\n  }\n\n  .shadow {\n    border-color: #468cff !important;\n  }\n\n  li {\n    list-style: none;\n  }\n\n  .el-button--primary {\n    width: 100%;\n    font-size: 12px;\n    font-weight: normal;\n    letter-spacing: 2px;\n    background-color: @color1;\n    border-color: @color1;\n    border-radius: 0;\n\n    &:hover {\n      background-color: #4794ff;\n      border-color: #4794ff;\n    }\n  }\n\n  .drag-warp {\n    width: 100%;\n    height: 100%;\n  }\n\n  .components-widgets {\n    display: flex;\n    align-items: center;\n  }\n\n\n  //顶部logo\n\n  .component-type-cross-table {\n    background-position: 15px -875px;\n  }\n\n  .component-type-bar {\n    background-position: -143px -875px;\n  }\n\n  .component-type-pie {\n    background-position: -543px -875px;\n  }\n\n  .component-type-line {\n    background-position: -306px -875px;\n  }\n\n  .component-type-indicator-card {\n    background-position: -63px -875px;\n  }  \n  \n  .component-type-gauge {\n    background-position: -700px -880px\n  }\n\n\n  .seprate {\n    border-right: 1px solid hsla(0, 0%, 100%, .3);\n    width: 0;\n    height: 20px;\n    margin: 0 4px\n  }\n\n  .components-item {\n    width: 35px;\n    height: 35px;\n    border-radius: 2px;\n    margin: 0 2px;\n\n    :hover {\n      background-color: hsla(0, 0%, 100%, .15)\n    }\n\n    > div {\n      width: 70px;\n      height: 70px;\n      display: block;\n      position: relative;\n      left: 0;\n      top: 0;\n      background-image: url('../img/panel.png');\n      background-repeat: no-repeat;\n      -webkit-transform: scale(.5);\n      transform: scale(.5);\n      transform-origin: left top;\n      cursor: pointer;\n    }\n  }\n\n  .require-icon {\n    color: #f23c3c;\n    font-size: 14px;\n    margin-right: 4px;\n  }\n\n  .vue-grid-item.vue-grid-placeholder {\n    background: #ada3a3;\n  }\n\n  .ui-schema-antd-tree {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 8px 12px;\n    padding-top: 0;\n    box-sizing: border-box;\n    color: rgba(0, 0, 0, .65);\n    font-size: 14px;\n    font-variant: tabular-nums;\n    line-height: 1.5;\n    list-style: none;\n    font-feature-settings: \"tnum\";\n    margin: 0;\n\n    > li {\n      padding: 2px 0;\n    }\n\n    li {\n      margin: 0;\n      padding: 4px 0;\n      white-space: nowrap;\n      list-style: none;\n      outline: 0;\n    }\n\n    .field-tree-left {\n      cursor: pointer;\n\n      li {\n        .field-tree-item-warp {\n          padding-left: 29px;\n        }\n      }\n\n      ul {\n        padding-left: 0;\n      }\n\n      .open-rotate {\n        transform: rotate(90deg);\n      }\n\n      .el-icon-caret-right {\n        transition: all 0.3s;\n        color: @base-color;\n        font-size: 12px;\n      }\n\n      .field-tree-item-warp-flex{\n        display: flex;\n        align-items: center;\n      }\n\n      .field-tree-item-warp {\n        transition: all 0.3s;\n        flex: 1;\n        margin-left: 4px;\n        .bi_dashboard_text_overflow\n\n        &:hover {\n          background-color: hsla(0, 0%, 100%, .1);\n        }\n      }\n\n      .field-tree-text {\n        max-width: 140px;\n        color: @base-color;\n        font-size: 12px;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n        display: inline-block;\n        line-height: 1;\n      }\n    }\n  }\n}\n\n.jzliu-bi-engine-vertical-text {\n  height: 60px;\n  width: 100%;\n  color: var(--bi-jz-font-color);\n  font-size: 14px;\n  letter-spacing: 3px;\n  cursor: pointer;\n  writing-mode: tb-rl;\n  writing-mode: vertical-lr;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  &:hover {\n    color: #5890FF;\n  }\n}\n\n/* Element UI 组件 label 样式 */\n.cdsp_dashboard .el-input__label,\n.cdsp_dashboard .el-form-item__label,\n.cdsp_dashboard .el-checkbox__label,\n.cdsp_dashboard .el-radio__label,\n.cdsp_dashboard .el-select__label,\n.cdsp_dashboard .el-cascader__label,\n.cdsp_dashboard .el-date-editor__label,\n.cdsp_dashboard .el-time-picker__label,\n.cdsp_dashboard .el-switch__label,\n.cdsp_dashboard .el-slider__label,\n.cdsp_dashboard .el-rate__label,\n.cdsp_dashboard .el-color-picker__label,\n.cdsp_dashboard .el-transfer__label,\n.cdsp_dashboard .el-upload__label,\n.cdsp_dashboard .el-button__label,\n.cdsp_dashboard .el-tag__label,\n.cdsp_dashboard .el-badge__label,\n.cdsp_dashboard .el-alert__label,\n.cdsp_dashboard .el-message__label,\n.cdsp_dashboard .el-notification__label,\n.cdsp_dashboard .el-dialog__label,\n.cdsp_dashboard .el-drawer__label,\n.cdsp_dashboard .el-popover__label,\n.cdsp_dashboard .el-tooltip__label,\n.cdsp_dashboard .el-pagination__label,\n.cdsp_dashboard .el-table__label,\n.cdsp_dashboard .el-tree__label,\n.cdsp_dashboard .el-menu__label,\n.cdsp_dashboard .el-breadcrumb__label,\n.cdsp_dashboard .el-steps__label,\n.cdsp_dashboard .el-tabs__label,\n.cdsp_dashboard .el-card__label,\n.cdsp_dashboard .el-collapse__label,\n.cdsp_dashboard .el-timeline__label,\n.cdsp_dashboard .el-carousel__label,\n.cdsp_dashboard .el-image__label,\n.cdsp_dashboard .el-avatar__label,\n.cdsp_dashboard .el-skeleton__label,\n.cdsp_dashboard .el-empty__label,\n.cdsp_dashboard .el-result__label,\n.cdsp_dashboard .el-descriptions__label,\n.cdsp_dashboard .el-calendar__label,\n.cdsp_dashboard .el-backtop__label,\n.cdsp_dashboard .el-affix__label,\n.cdsp_dashboard .el-anchor__label,\n.cdsp_dashboard .el-page-header__label,\n.cdsp_dashboard .el-divider__label,\n.cdsp_dashboard .el-link__label,\n.cdsp_dashboard .el-text__label,\n.cdsp_dashboard .el-space__label,\n.cdsp_dashboard .el-scrollbar__label,\n.cdsp_dashboard .el-infinite-scroll__label,\n.cdsp_dashboard .el-loading__label,\n.cdsp_dashboard .el-message-box__label,\n.cdsp_dashboard .el-popconfirm__label,\n.cdsp_dashboard .el-autocomplete__label,\n.cdsp_dashboard .el-input-number__label,\n.cdsp_dashboard .el-rate__label,\n.cdsp_dashboard .el-slider__label,\n.cdsp_dashboard .el-switch__label,\n.cdsp_dashboard .el-time-select__label,\n.cdsp_dashboard .el-time-picker__label,\n.cdsp_dashboard .el-date-picker__label,\n.cdsp_dashboard .el-date-range-picker__label,\n.cdsp_dashboard .el-month-picker__label,\n.cdsp_dashboard .el-year-picker__label,\n.cdsp_dashboard .el-week-picker__label,.cdsp_dashboard .el-quarter-picker__label,\n.cdsp_dashboard .el-datetime-picker__label,\n.cdsp_dashboard .el-datetime-range-picker__label {\n  font-size: 12px !important;\n}\n\n.cdsp_dashboard .sortable-ghost {\n  margin: 9px 9px;\n  padding: 4px 8px;\n  background-color: var(--color-primary);\n  border: 1px dashed var(--color-primary);\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
